let addToCart = document.querySelector('.product-form__buttons').querySelector('button');

if (!addToCart.disabled) {
let options = document.querySelector('.product-form__input').querySelectorAll('input');
let labels = document.querySelector('.product-form__input').querySelectorAll('label');
  
let css = `
  #stickyAddToCart {
      max-width: 75%;
      min-height: 60px;
      position: fixed;
      bottom: 20px;
      background: #1f1f21;
      border-radius: 0 7px 7px 0;
      border-top: 1px solid #aaa;
      border-bottom: 1px solid #aaa;
      border-right: 1px solid #aaa;
      margin-left: -100%;
      transition: margin-left 0.5s ease-in-out;
      z-index: 44;
  }

  #stickyAddToCart::-webkit-scrollbar {
      display: none;
  }

  .showSticky {
      margin-left: 0px !important;
  }

  #stickyAddToCart .radio {
      display: inline-block;
      height: 30px;
      color: #ffffff;
      border-radius: 10px;
      background-color: none;
      padding-top: 2px;
      padding-left: 10px;
      padding-right: 10px;
      margin-right: 5px;
      border: 1px solid #aaa;
      cursor: pointer;
      margin-bottom: 10px;
  }

  #stickyAddToCart .radio-selected {
    background-color: #fff;
    color: #000;
  }

  #stickyAddToCart .addToCart {
      display: inline-block;
      height: 30px;
      color: #000;
      border-radius: 10px;
      background-color: #ffffff;
      padding-top: 2px;
      padding-left: 10px;
      padding-right: 10px;
      margin-right: 5px;
      cursor: pointer;
      margin-bottom: 10px;
  }

  #stickyAddToCart .buttonWrapper {
      margin-top: 14px;
      margin-left: 10px;
      margin-right: 5px;
  }
`;

let html = `
  <div id="stickyAddToCart">
    <div class="buttonWrapper">
    </div>
  </div>;
`;

var style = document.createElement('style');
style.type = 'text/css';
if (style.styleSheet) {
    style.styleSheet.cssText = css;
} else {
    style.appendChild(document.createTextNode(css));
}

// Append the style element to the head
document.head.appendChild(style);

var newDiv = document.createElement('div');
newDiv.innerHTML = html;
document.body.appendChild(newDiv);

let stickyRoot = document.querySelector('#stickyAddToCart');
let wrapper = stickyRoot.querySelector('.buttonWrapper');

  let optionHTML = '';
  if (options.length > 1) {
options.forEach((option, index) => {
  optionHTML += `<div class="radio" onClick="javascript:stickyAddToCart(${index})">${option.value.split('(')[0].trim()}</div>`;
});

    try {
    labels.forEach(label => {
      if (label.innerText.includes('feet')) {
        label.innerText = label.innerText.replace(' feet', 'ft').replace('+', 'Std+');
      }
    });
    } catch(e) { }
  }

  optionHTML += '<div class="addToCart" onClick="javascript:stickyAddToCart(true)">Add to Cart</div>';
wrapper.innerHTML = optionHTML;

let buttons = stickyRoot.querySelectorAll('.radio');

let observer = new IntersectionObserver(entries => {
  let intersecting = false;
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      intersecting = true;
    }
  });

  if (intersecting) {
    stickyRoot.classList.remove('showSticky')
  } else {
    // stickyRoot.classList.add('showSticky');
  }
}, {root: null, rootMargin: '0px', threshold: 0.1});
  observer.observe(addToCart);
  // observer.observe(document.querySelector('variant-radios'));


  var preventClick = false;
window.stickyAddToCart = function(index) {
  if (index === true) {
     if (preventClick) return;
    preventClick = true;
    setTimeout(_ => preventClick = false, 500);
    return addToCart.click();
  }
  
  labels[index].click();
}

setInterval(_ => {
  buttons.forEach(button => button.classList.remove('radio-selected'));
  options.forEach((option, index) => {
      if (option.checked) {
        buttons[index].classList.add('radio-selected');
      }
  });
}, 250);

}